import determineActorComObjectFunction, { equalDPT } from "../KnxProductDataTools/determineActorComObjectFunction";
import determineButtonComObjectFunction from "../KnxProductDataTools/determineButtonComObjectFunction";
import KnxProductData from "../KnxProductdata";
import Signal from "../models/Signal";
import SignalType from "../models/SignalType";
import SignalTypes, { descriptionForSignalType, getSignalTypeByName } from "../models/SignalTypes";
import { isUiModeProductAdmin } from "../uiMode";
import { itx } from "../translationItx/itx";

export default function ManualSignalTypeSelection(props: {
  knxProductData: KnxProductData | undefined;
  signal: Signal;
  isActor?: boolean;
}) {
  const { knxProductData, signal, isActor } = props;
  function getPossibleSignalTypesFromRules(): Array<SignalType> {
    const res = new Set<SignalType>();
    ////from rules
    //const allRules = isActor ? allActorRuleArraysInOne : allButtonRuleArraysInOne;
    var datapointType = signal.knxDatapointType;

    function getStringOfBitDpts(bit: number): Array<string> {
      const res = new Array<string>();
      if (bit > 0) {
        res.push(`@ ${bit} bit`);
        res.push(`@ ${bit} bits`);
        if (bit % 8 == 0) {
          const byte = bit / 8;
          res.push(`@ ${byte} byte`);
          res.push(`@ ${byte} bytes`);
        }
      }
      return res;
    }

    // allRules.forEach((rule) => {
    //   if (equalDPT(rule.dpts, datapointType)) {
    //     res.add(rule.signalType);
    //   }
    // });
    // from self defined
    // const dptPossibillities = dPTSignalTypesManualList;
    // for (let i in dptPossibillities) {
    //   const entry = dptPossibillities[i];

    //   if (equalDPT([entry.dpt], datapointType)) {
    //     entry.signalTypes.forEach((signalType) => {
    //       if (signal.type != signalType) {
    //         res.add(signalType);
    //       }
    //     });
    //   }
    // }
    if (datapointType.includes("@")) {
      SignalType.allSignalTypes.forEach((st) => {
        if (st.dpts) {
          const bit = SignalType.getBitsizeOfDpts(st.dpts[0]);
          const stringBits = getStringOfBitDpts(bit);
          if (stringBits.includes(datapointType)) {
            res.add(st);
          }
        }
      });
    }

    return [...res];
  }

  if (knxProductData && isUiModeProductAdmin()) {
    const options = new Array<any>();
    const optionsNames = new Array<SignalType>();

    let possibleSignalTypes = new Array<SignalType>();

    possibleSignalTypes.push(signal.type);
    getPossibleSignalTypesFromRules().forEach((signalTypesFromRules) => {
      if (!possibleSignalTypes.includes(signalTypesFromRules)) {
        possibleSignalTypes.push(signalTypesFromRules);
      }
    });
    if (possibleSignalTypes.length == 1) {
      SignalType.allSignalTypes.forEach((signalType) => {
        if (signal.type != signalType) {
          possibleSignalTypes.push(signalType);
        }
      });
    }

    // if (!possibleSignalTypes.includes(signalType)) {
    //   options.push(
    //     <option key={"remove"} value="remove">
    //       Remove Manual SignalType
    //     </option>,
    //   ); // no itx

    options.push(
      <option key={"autoDef"} value={""}>
        {itx("knxManualChannelTypeSelection.autoDef", "automatisch def")}
      </option>,
    );

    for (const signalTypeName in SignalTypes) {
      const signalType = SignalTypes[signalTypeName];
      if (signalType) {
        optionsNames.push(signalType);
      }
    }
    optionsNames
      .sort((a, b) => a.name.localeCompare(b.name))
      .forEach((sign) => {
        options.push(
          <option key={sign.name} value={sign.name}>
            {sign.description?.en}
          </option>,
        );
      });

    // possibleSignalTypes
    //   .sort((a, b) => {
    //     return a.name.localeCompare(b.name);
    //   })
    //   .forEach((s) => {
    //     let optionText = s.name;
    //     if (s.isIgnored) {
    //       optionText = "(" + optionText + ")";
    //     }
    //     options.push(
    //       <option key={optionText} value={s.name}>
    //         {optionText}
    //       </option>,
    //     );
    //   });

    let backgroundColor: string | undefined = undefined;
    if (signal.determinedFromId == "manual") {
      backgroundColor = "yellow";
    } else if (signal.determinedFromId == "manualViaScript") {
      backgroundColor = "lightblue";
    }

    return (
      <div style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
        <select
          className="select"
          style={{ width: "300px", backgroundColor: backgroundColor }}
          defaultValue={signal.type.name}
          key={signal.type.name}
          onChange={(ev) => {
            if (ev.target.value == "" || ev.target.value == "remove") {
              knxProductData.config.setSignalTypeMapping(signal.knxId, undefined);
              if (isActor) {
                determineActorComObjectFunction(signal);
              } else {
                determineButtonComObjectFunction(signal);
              }
              ev.target.value = signal.type.name;
            } else {
              const signalType = getSignalTypeByName(ev.target.value);

              signal.determinedFromId = "manual"; // no itx
              signal.type = signalType;
              knxProductData.config.setSignalTypeMapping(signal.knxId, signalType);
            }
            // trick um die gesamte liste neu zu rendern
            // (signal.parent?.parent as Device)?.knxChannels.raiseOnChange("knxSignal.type");
          }}
        >
          {options}
        </select>
        {signal.determinedFromId == "manual" && (
          <div>&nbsp;{itx("knxManualChannelTypeSelection.manual", "manual")}</div>
        )}
        {signal.determinedFromId == "manualViaScript" && (
          <div>
            &nbsp;{itx("knxManualChannelTypeSelection.manualViaScript", "manualViaScript")} <br />
            {isUiModeProductAdmin() && (signal.oldType?.description?.en || "test")}
          </div>
        )}
      </div>
    );
  }
  return <div>{descriptionForSignalType(signal.type)}</div>;
}
